import React, { useEffect } from 'react';
import { Buffer } from 'buffer';
import { useRouter } from 'next/router';
import { useOnboarder } from '../OnboarderContext';

interface UseRawUrlDataIfApplicableProps {
    children: React.ReactNode;
}

export function UseRawUrlDataIfApplicable({ children }: UseRawUrlDataIfApplicableProps) {
    const router = useRouter();

    const [, rawUrlData] = router.query?.params || [];
    const {
        data,
        saveData,
        config: { basePath },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } = useOnboarder<{ [key: string]: any }>();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let urlData: any;
    try {
        urlData = JSON.parse(Buffer.from(decodeURIComponent(rawUrlData), 'base64').toString());
    } catch (error) {
        // This should only happen if the url data has been tempered with
        router.replace(basePath);
        return null;
    }

    // FIXME: Rule of hooks violations cleanup https://gitlab.com/vistaprint-org/99designs/frontend/-/issues/3523
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        if (urlData) {
            saveData({ ...data, ...urlData });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (Object.keys(data).length <= 0) {
        return null;
    }

    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>;
}
